<xform-page [sidebar]="true" [bgColor]="'sysAdm-bg'">
  <router-outlet></router-outlet>
</xform-page>
